// extracted by mini-css-extract-plugin
module.exports = {"kayak-select-label":"styles_kayak-select-label__2wnAz","kayakSelectLabel":"styles_kayak-select-label__2wnAz"};